import { gql } from "lib/apolloClient";
import {
  unitFlowFragment,
  unitFlowFragmentWithoutDepth,
  unitFlowOutlineFragment,
  unitResourceFragment,
} from "./Fragments";

export const getUnitFlowFeedQuery = gql`
  query getUnitFlow(
    $parentId: ID!
    $parentType: ENTITY_TYPE_ENUM!
    $orderBy: ORDER_BY_ENUM
    $filters: EntityFlowResourceFilter
    $after: String
  ) {
    node(id: $parentId, type: $parentType) {
      ... on UnitPlan {
        id
        unitFlowFeed {
          unitFlowId
          unitFlowFlatFeed(
            first: 100
            after: $after
            orderBy: $orderBy
            orderByDirection: ASC
            filters: $filters
          ) {
            edges {
              node {
                ...unitFlowWithChildrenItem
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              __typename
            }
            resourceBasedCount {
              totalCount
              fileCount
              folderCount
              __typename
            }
          }
        }
      }
      __typename
    }
  }
  ${unitFlowFragment.unitFlowWithChildren}
`;

export const getUnitFlowOutlineFeedQuery = gql`
  query getUnitFlow(
    $parentId: ID!
    $parentType: ENTITY_TYPE_ENUM!
    $filters: EntityFlowResourceFilter
  ) {
    node(id: $parentId, type: $parentType) {
      ... on UnitPlan {
        id
        unitFlowFeed {
          unitFlowId
          unitFlowOutline(filters: $filters) {
            id
            label
            depth
            ...unitFlowOutlineItem
          }
        }
      }
    }
  }
  ${unitFlowOutlineFragment.unitFlowOutlineItem}
`;

export const getEntityFlowResourceMultiNodeQuery = gql`
  query getOrganizatonResources(
    $ids: [ID!]
    $filters: EntityFlowResourceFilter
  ) {
    multiNode(ids: $ids, type: ENTITY_FLOW_RESOURCE) {
      ... on EntityFlowResource {
        ...unitFlowWithChildrenItem
      }
    }
  }
  ${unitFlowFragmentWithoutDepth.unitFlowWithChildren}
`;

export const getEntireUnitFlowFeedQuery = gql`
  query getEntireUnitFlowFeed(
    $parentId: ID!
    $filters: EntityFlowResourceFilter
  ) {
    node(id: $parentId, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        unitFlowFeed {
          unitFlowId
          unitResourceId
          unitFlowFlatFeed(
            orderBy: DISPLAY_SEQUENCE
            filters: $filters
            orderByDirection: ASC
            first: 10000
          ) {
            edges {
              node {
                id
                label
                depth
                resourceType: itemType
                parent {
                  id
                }
                item {
                  id
                  ... on Assessment {
                    type
                    academicTerm {
                      id
                      label
                      lockingStatus
                    }
                    assessmentType {
                      id
                      value
                    }
                  }
                }
                isRepeated
                repeatedResources
                childrenV2: children(filters: $filters) {
                  id
                }
                ...childrenHierarchyInfo
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              __typename
            }
            resourceBasedCount {
              totalCount
              __typename
            }
          }
        }
        __typename
      }
    }
  }
  ${unitFlowFragment.childrenHierarchyInfoFragment}
`;

export const getUnitResourcesFeedQuery = gql`
  query getUnitResourcesFeed(
    $parentId: ID!
    $filters: EntityFlowResourceFilter
    $after: String
    $first: Int
  ) {
    node(id: $parentId, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        unitFlowFeed {
          unitFlowId
          unitResourceId
          unitFlowFlatFeed(
            orderBy: DISPLAY_SEQUENCE
            filters: $filters
            orderByDirection: ASC
            after: $after
            first: $first
          ) {
            edges {
              node {
                ...unitResourceItem
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              __typename
            }
            resourceBasedCount {
              totalCount
              __typename
            }
          }
        }
        __typename
      }
    }
  }
  ${unitResourceFragment}
`;

export const getUnitResourcesCountQuery = gql`
  query getUnitResourcesCount(
    $parentId: ID!
    $filters: EntityFlowResourceFilter
  ) {
    node(id: $parentId, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        unitFlowFeed {
          unitFlowFlatFeed(filters: $filters) {
            resourceBasedCount {
              totalCount
              __typename
            }
          }
        }
        __typename
      }
    }
  }
`;
